import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AssistBotService } from './assist-bot.service';
import { NotifierService } from '../../../services/Notifierservice';

@Component({
  standalone: false,
  selector: 'app-aiassist',
  templateUrl: './aiassist.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./aiassist.component.scss']
})
export class AIAssistComponent {

  autoSearchDafaultValue:string="";
  suggestionEnable:boolean=false;
  suggestionList:any=[];
  language:string="eng";
  chatbotData:any=[];
  private readonly notifier: NotifierService;
  constructor(private readonly assistBotService:AssistBotService,private readonly notifierService: NotifierService,) {
    this.notifier = notifierService;
   }

  setautoComplete(value:any){
    this.autoSearchDafaultValue=value['data'];
      if(value['action'] != "Keypress"){
        this.save();
      }
  }

  save(){
   
    if(this.autoSearchDafaultValue.trim()==""){
      this.notifier.notify('default','Please enter your question');
      return;
    }
    let answerData = [{
      "questionId": '',
      "bot_type": "bot",
      "question": this.autoSearchDafaultValue.trim(),
      "answer": "",
      "search":true
    }];
    this.chatbotData.unshift(answerData[0]);
    setTimeout(()=>{
      this.autoSearchDafaultValue="";
      },1500);
  }

}
